import React from 'react';
import ChatHistory from '../components/Chat/ChatHistory';
import '../assets/css/chat.css';

const Chat: React.FC = () => {
  return (
    <div className="flex-grow-1 container-p-y chat-page">
      <div className="app-chat card overflow-hidden chat-shell">
        <div className="row g-0">
          <ChatHistory />
        </div>
      </div>
    </div>
  );
}; 

export default Chat;
